import type { WorkItemDto } from '@customTypes/types';
import { WorkItemStatus } from '@customTypes/types';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { notificationStyleConfig } from '@/features/notification/config/notificationConfig';
import {
  useAcceptWorkRequestMutation,
  useRejectWorkRequestMutation
} from '@/features/work/api';
import { translate } from '@/shared/i18n/translate';

import { interactionWorkItemsStatusFilters } from '../../constants';

export const useManageWorkRequestView = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const route = useRouter();
  const queryClient = useQueryClient();
  const rejectWorkRequestMutation = useRejectWorkRequestMutation();
  const acceptWorkRequestMutation = useAcceptWorkRequestMutation();

  useEffect(() => {
    if (workItem.status === WorkItemStatus.Pending) {
      notifications.show({
        title: translate('notifications.giveResponseFormWorkItem'),
        ...notificationStyleConfig
      });
    }
  }, []);

  const reject = async () => {
    await rejectWorkRequestMutation.mutateAsync(
      {
        params: {
          workRequestId: workItem.workItemId.toString()
        }
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [
              'ClubWorkItemsList',
              workItem.clubProfileId.toString(),
              interactionWorkItemsStatusFilters
            ],
            exact: true
          });
          notifications.show({
            title: translate('notifications.workInviteRejected'),
            ...notificationStyleConfig
          });

          route.history.back();
        }
      }
    );
  };
  const accept = async () => {
    await acceptWorkRequestMutation.mutateAsync(
      {
        params: {
          workRequestId: workItem.workItemId.toString()
        }
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [
              'ClubWorkItemsList',
              workItem.clubProfileId.toString(),
              interactionWorkItemsStatusFilters
            ],
            exact: true
          });
          notifications.show({
            title: translate('notifications.workStartOnArtistArrivalConfirm'),
            ...notificationStyleConfig
          });
        }
      }
    );
  };

  return {
    state: {},
    functions: { reject, accept }
  };
};
